import React, { useState } from 'react';
import Clipboard from 'clipboard';
import {
  Button,
  CheckIcon,
  v2neutral100,
  v2blue600,
  v2green400,
  v2white,
  TextDisplay,
} from '@paypalcorp/pp-react';
import styles from './CopyButton.less';

const CopyButton = ({ clickCopy = () => {}, text, copyText }) => {
  new Clipboard('#clipBoardTrigger');
  const [isCopied, setIsCopied] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <div
        className={`${styles['copy-container']}`}
        style={{
          backgroundColor: v2neutral100,
        }}
      >
        <TextDisplay
          className={`${styles['text-to-copy']}`}
          id={'clipBoardBodyText'}
          value={text}
        />
        <Button
          theme='v2'
          size='sm'
          id='clipBoardTrigger'
          className={`${styles['clip-btn-style']}`}
          data-clipboard-target='#clipBoardBodyText'
          style={
            isCopied
              ? {
                  border: 'none',
                  backgroundColor: v2green400,
                  color: v2white,
                }
              : {
                  backgroundColor: v2white,
                  borderColor: v2blue600,
                  color: v2blue600,
                }
          }
          onClick={(e) => {
            if (!isCopied) {
              clickCopy(e);
            }
            setIsCopied(!isCopied);
          }}
        >
          {!isCopied ? copyText : <CheckIcon size='sm' />}
        </Button>
      </div>
    </div>
  );
};

export default CopyButton;
